import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { createUri, Api } from '@api/utils';

enum TicketsUrl {
    Create = 'create',
    Prefill = 'prefill',
}

export const ticketsHooks = createApi({
    reducerPath: 'ticketsApi',
    baseQuery: fetchBaseQuery({
        baseUrl: createUri(Api.Tickets, '/tickets/V1'),
    }),
    endpoints: (build) => ({
        ticketSubmission: build.mutation<string, Record<string, string>>({
            query: ({ ...body }) => ({
                url: TicketsUrl.Create,
                method: 'POST',
                body,
                responseHandler: (response) => response.text(),
            }),
        }),
        ticketPrefill: build.query<{ locationName: string, companyName: string }, Record<string, string>>({
            query: ({ ...params }) => ({
              url: TicketsUrl.Prefill,
              method: 'GET',
              params
            })
        })
    }),
});


export const { useTicketSubmissionMutation, useTicketPrefillQuery } = ticketsHooks;
